import React from 'react';
import LocalImages from '../../../../static';

type ActivityFilterItemProps = {
  label: string;
  iconName: keyof typeof LocalImages;
  onPress: () => void;
  isSelected: boolean;
}

const ActivityFilterItem: React.FC<ActivityFilterItemProps> = ({ label, iconName, onPress, isSelected  }) => {
  
  return (
    <div onClick={onPress} className={`filter-item ${isSelected ? 'active' : ''}`}>
        <img src={LocalImages[iconName] || iconName} alt={LocalImages[iconName] || 'icon'}/>
        <p>{label}</p>
    </div>
  );
};

export default ActivityFilterItem;
